export default __webpack_public_path__ + "static/media/221111_finishlist.1e288461.pdf";